export class GisAddonPurchaseRequest
{
   
        LicenseKey: string;
        ProductID : number;
        CreditCardID : number;
        IsFree : boolean;
}